(function() { window.GUID_0d3651a3_a1e3_4780_bc04_e960af1b9e04 = { getGuid: function() { return "0d3651a3-a1e3-4780-bc04-e960af1b9e04"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-csratedetails",
                        callback: (accordion, e) => {
                            const $pageHeader = accordion.$Control.parent();
                            const onlySummaryGraph = accordion.$Control
                                .find(`#CSRateDetailsSectionOnlySummaryGraph-${accordion.ContentId}`)
                                .val() == "true";
                            let accordionReadyCounter = 0;
                            const _accordionReadyCounter = $pageHeader.attr("data-accordion-ready-counter") || 0;
                            if (_accordionReadyCounter) {
                                accordionReadyCounter = parseInt(_accordionReadyCounter);
                            }
                            accordionReadyCounter++;
                            $pageHeader.attr("data-accordion-ready-counter", accordionReadyCounter);
                            if (accordion.IsExpanded) {
                                CS.Lag("CSRateDetailsSectionCharts", 250, () => {
                                    setTextContent(accordion);
                                    //const overviewData = extractOverviewData(accordion);
                                    if ( /* overviewData && */accordionReadyCounter <= 1) {
                                        initializeOverview(accordion);
                                        //initializeTCSRWeeklyVariationChartOverviewV2(
                                        //  overviewData,
                                        //  accordion
                                        //);
                                        //initalizeTCSRWeekDetails(accordion, undefined, true);
                                        //bindTCSRWeekPickerEvents(accordion);
                                    }
                                    const byEventData = extractDataFromGameHistory(accordion);
                                    if (byEventData) {
                                        initializeTCSRWeeklyVariationChartFromGameHistory(byEventData.data, accordion, byEventData.allDataPointsHaveNegativeValues, byEventData.allDataPointsHaveNullValue, byEventData.allDataPointsHavePositiveValues);
                                        bindTimeframePickerEvents(accordion);
                                    }
                                });
                            }
                        },
                    });
                    function extractOverviewData(accordion) {
                        var _a, _b;
                        const $dataInput = $(`#CSRateDetailsSectionWeeklyData-${accordion.ContentId}`);
                        if (!$dataInput.length)
                            return null;
                        const data = JSON.parse($dataInput.val());
                        if (data.datasets) {
                            const lang = ((_b = (_a = CS.CommonData.Current.Language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "en");
                            moment.locale(lang);
                            data.datasets.forEach((dataset) => {
                                if (dataset.data) {
                                    dataset.data.forEach((dataPoint) => {
                                        dataPoint.displayStartDate = moment(dataPoint.startDate).format(`LL`);
                                        dataPoint.displayEndDate = moment(dataPoint.endDate).format(`LL`);
                                    });
                                }
                            });
                        }
                        return data;
                    }
                    function extractDataFromGameHistory(accordion) {
                        var _a, _b;
                        const $dataInput = $(`#CSRateDetailsSectionGraphData-${accordion.ContentId}`);
                        if (!$dataInput.length)
                            return null;
                        const data = JSON.parse($dataInput.val());
                        let allDataPointsHavePositiveValues = true;
                        let allDataPointsHaveNegativeValues = true;
                        let allDataPointsHaveNullValue = true;
                        if (data.datasets) {
                            const lang = ((_b = (_a = CS.CommonData.Current.Language) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : "en");
                            moment.locale(lang);
                            data.datasets.forEach((dataset) => {
                                if (dataset.data) {
                                    dataset.data.forEach((dataPoint) => {
                                        dataPoint.displayStartDate = moment(dataPoint.startDate).format(`ll`);
                                        dataPoint.displayStartTime = moment(dataPoint.startDate).format(`LT`);
                                        dataPoint.displayEndDate = moment(dataPoint.endDate).format(`ll`);
                                        if (dataPoint.valueA > 0) {
                                            allDataPointsHaveNegativeValues = false;
                                            allDataPointsHaveNullValue = false;
                                        }
                                        else if (dataPoint.valueA < 0) {
                                            allDataPointsHavePositiveValues = false;
                                            allDataPointsHaveNullValue = false;
                                        }
                                    });
                                }
                            });
                        }
                        return {
                            data,
                            allDataPointsHavePositiveValues,
                            allDataPointsHaveNegativeValues,
                            allDataPointsHaveNullValue,
                        };
                    }
                    function setTextContent(accordion) {
                        const $totalVariationElement = accordion.$Content.find(".CSRateDetailsSectionTotalVariation");
                        if ($totalVariationElement.length) {
                            $totalVariationElement.css({
                                textAlign: "center",
                                fontSize: "0.8em",
                                fontStyle: "italic",
                                background: `linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0) 100%)`,
                                padding: "4px",
                            });
                            const $value = $totalVariationElement.find(".value");
                            const isPositive = $value.attr("data-positive") == "True";
                            if (isPositive) {
                                $value.css("color", "#00b300");
                            }
                            else {
                                // TODO: Moins contrasté comme couleur
                                $value.css("color", "#ff0000");
                            }
                            $value.css({
                                fontWeight: "bold",
                                fontSize: "1.2em",
                            });
                            const $label = $totalVariationElement.find(".label");
                            const tab = $label.attr("data-tab");
                            if (tab == "events") {
                                $label.text(JSRess.TotalTCSRVariationDuringThisEvent);
                            }
                            else if (tab == "opponents") {
                                $label.text(JSRess.TotalTCSRVariationAgainstThisOpponent);
                            }
                        }
                        const $title1 = $(`#CSRateDetailsSectionCSRTitle-${accordion.ContentId}`);
                        const $summary1 = $(`#CSRateDetailsSectionCSRSummary-${accordion.ContentId}`);
                        if ($title1.length) {
                            $title1.text(JSRess.CSRWeeklyEvolution);
                        }
                        if ($summary1.length) {
                            $summary1.html(JSRess.TCSRDescription01);
                        }
                        const $title2 = $(`#CSRateDetailsSectionWeeklyTitle-${accordion.ContentId}`);
                        if ($title2.length) {
                            $title2.text(JSRess.TCSR12WeeksVariation);
                        }
                        const $titleCSR = $(`#CSRateDetailsSectionTitle-${accordion.ContentId}`);
                        const $summaryCSR = $(`#CSRateDetailsSectionSummary-${accordion.ContentId}`);
                        const $titleTCSR = $(`#TemporaryCSRateDetailsSectionTitle-${accordion.ContentId}`);
                        const $summaryTCSR = $(`#TemporaryCSRateDetailsSectionSummary-${accordion.ContentId}`);
                        const descriptionCSR = JSRess.CSRDescription01;
                        const descriptionTCSR = JSRess.TCSRDescription01;
                        if ($titleCSR.length) {
                            $titleCSR.text(JSRess.WhatIsTheCSR);
                        }
                        if ($titleTCSR.length) {
                            $titleTCSR.text(JSRess.WhatIsTheTCSR);
                        }
                        if ($summaryCSR.length) {
                            $summaryCSR.html(descriptionCSR);
                        }
                        if ($summaryTCSR.length) {
                            $summaryTCSR.html(descriptionTCSR);
                        }
                    }
                    function bindTCSRWeekPickerEvents(accordion) {
                        CS.Controls.DropDownPicker.Events.ListItemClicked({
                            selector: "body",
                            childSelector: `#dropdown-csr-details-week-picker-${accordion.ContentId}`,
                            callback: (list, e) => {
                                const { value, extraValues, innerText } = e.data;
                                const $picker = $(`[data-pickerof="dropdown-csr-details-week-picker-${accordion.ContentId}"]`);
                                if ($picker) {
                                    $picker.html(innerText);
                                    initalizeTCSRWeekDetails(accordion, value);
                                }
                            },
                        });
                    }
                    function bindTimeframePickerEvents(accordion) {
                        CS.Controls.DropDownPicker.Events.ListItemClicked({
                            selector: "body",
                            childSelector: `#dropdown-timeframe-picker-${accordion.ContentId}`,
                            callback: (list, e) => {
                                const { value, extraValues, innerText } = e.data;
                                const $picker = $(`[data-pickerof="dropdown-timeframe-picker-${accordion.ContentId}"]`);
                                if ($picker) {
                                    $picker.html(innerText);
                                }
                            },
                        });
                    }
                    function initalizeTCSRWeekDetails(accordion, date, preventScroll) {
                        const $canvasContainer = accordion.$Content.find(`#CSRateDetailsSectionTCSRWeekDetailsCanvasContainer-${accordion.ContentId}`);
                        if (!$canvasContainer.length)
                            return;
                        const $userIdInput = $(`#CSRateDetailsSectionWeeklyHiddenValueUserId-${accordion.ContentId}`);
                        const $entityBaseIdInput = $(`#CSRateDetailsSectionWeeklyHiddenValueEntityBaseId-${accordion.ContentId}`);
                        const $dateInput = $(`#CSRateDetailsSectionWeeklyHiddenValueDate-${accordion.ContentId}`);
                        const $matchIdInput = $(`#CSRateDetailsSectionWeeklyHiddenValueMatchId-${accordion.ContentId}`);
                        if (!$userIdInput.length)
                            return;
                        if (!$entityBaseIdInput.length)
                            return;
                        if (!$dateInput.length)
                            return;
                        let overrideMatchId = null;
                        if ($matchIdInput.length) {
                            overrideMatchId = $matchIdInput.val();
                        }
                        let userId, entityBaseId;
                        userId = $userIdInput.val();
                        entityBaseId = $entityBaseIdInput.val();
                        if (!date)
                            date = $dateInput.val();
                        const _data = {
                            userId,
                            entityBaseId,
                            date,
                            overrideMatchId,
                        };
                        const url = CS.Url.CSUrl("CSRDetailsWeekDetailsPopup");
                        if (url) {
                            $canvasContainer.html("");
                            CS.Helper.ShowLoader({
                                id: "CSRateDetailsSectionTCSRWeekDetails",
                                $container: () => $canvasContainer,
                                overContent: false,
                                position: "prepend",
                            });
                            if (!preventScroll) {
                                const $picker = accordion.$Content.find(".week-picker-container");
                                if ($picker.length) {
                                    const pickerRect = $picker[0].getBoundingClientRect();
                                    const scrollTop = window.pageYOffset;
                                    CS.DOM.$body.addClass("prevent-scrolling");
                                    $([document.documentElement, document.body]).animate({
                                        scrollTop: scrollTop + pickerRect.top - 100,
                                    }, 500, () => {
                                        CS.DOM.$body.removeClass("prevent-scrolling");
                                        try {
                                            CS.Ajax.Get(url, _data, (response) => {
                                                const $response = $(response);
                                                const $innerContent = $response.find(".csr-details-week-details-drawer-content");
                                                $canvasContainer.html($innerContent[0].outerHTML);
                                                CS.Helper.RemoveLoader({
                                                    id: "CSRateDetailsSectionTCSRWeekDetails",
                                                    $container: $canvasContainer,
                                                });
                                            });
                                        }
                                        catch (e) {
                                            console.error(e);
                                            CS.Helper.RemoveLoader({
                                                id: "CSRateDetailsSectionTCSRWeekDetails",
                                                $container: $canvasContainer,
                                            });
                                        }
                                    });
                                }
                            }
                            else {
                                try {
                                    CS.Ajax.Get(url, _data, (response) => {
                                        const $response = $(response);
                                        const $innerContent = $response.find(".csr-details-week-details-drawer-content");
                                        $canvasContainer.html($innerContent[0].outerHTML);
                                        CS.Helper.RemoveLoader({
                                            id: "CSRateDetailsSectionTCSRWeekDetails",
                                            $container: $canvasContainer,
                                        });
                                    });
                                }
                                catch (e) {
                                    console.error(e);
                                    CS.Helper.RemoveLoader({
                                        id: "CSRateDetailsSectionTCSRWeekDetails",
                                        $container: $canvasContainer,
                                    });
                                }
                            }
                        }
                    }
                    function initializeTCSRWeeklyVariationChartFromGameHistory(data, accordion, allDataPointsHaveNegativeValues, allDataPointsHaveNullValues, allDataPointsHavePositiveValues) {
                        const $title1 = $(`#CSRateDetailsSectionCSRTitle-${accordion.ContentId}`);
                        if ($title1.length) {
                            $title1.text(JSRess.TCSRVariationByGame);
                        }
                        const $title2 = $(`#CSRateDetailsSectionCSRTitle2-${accordion.ContentId}`);
                        if ($title2.length) {
                            $title2.text(JSRess.GameHistory);
                        }
                        const canvas = document.getElementById(`CSRateDetailsSectionCanvas-${accordion.ContentId}`);
                        if (!canvas)
                            return;
                        if (!data || !data.datasets || !data.datasets.length) {
                            canvas.style.display = "none";
                            return;
                        }
                        canvas.style.display = "none";
                        const dataset = data.datasets.find((d) => d.id === "t-csr-weekly-variation");
                        if (!dataset)
                            return;
                        const parsedData = dataset.data.map((d) => {
                            const isPositiveValue = d.valueA > 0;
                            let backgroundColor = "";
                            let borderColor = "";
                            if (isPositiveValue) {
                                backgroundColor = "rgba(0,255,0,0.5)";
                                // borderColor = "rgba(0,255,0,0.5)";
                            }
                            else {
                                backgroundColor = "rgba(255,0,0,0.5)";
                                // borderColor = "rgba(255,0,0,0.5)";
                            }
                            borderColor = backgroundColor;
                            return {
                                x: d.x.replace(",", "."),
                                y: d.y,
                                valueA: d.valueA,
                                valueB: d.valueB,
                                valueC: d.valueC,
                                label: d.label,
                                backgroundColor: backgroundColor,
                                borderColor: borderColor,
                                startDate: d.startDate,
                                endDate: d.endDate,
                                userId: d.userId,
                                entityBaseId: d.entityBaseId,
                                gameId: d.gameId,
                                opponentEntityBaseId: d.opponentEntityBaseId,
                                opponentName: d.opponentName,
                                opponentImageUrl: d.opponentImageUrl,
                                displayStartDate: d.displayStartDate,
                                displayEndDate: d.displayEndDate,
                                displayStartTime: d.displayStartTime,
                            };
                        });
                        if (!parsedData || !parsedData.length) {
                            return;
                        }
                        const canvasId = canvas.id;
                        const newChartId = `${canvasId}-chartv2`;
                        const $newChartContainer = $(`<div id="${newChartId}" style="margin-top: 16px;"></div>`).insertBefore(canvas);
                        const maxX = Math.max(...parsedData.map((d) => d.valueA));
                        const minX = Math.min(...parsedData.map((d) => d.valueA));
                        const absoluteMaxX = Math.max(Math.abs(maxX), Math.abs(minX));
                        const datapoints = parsedData.map((d, index) => {
                            const id = `datapoint-${index}`;
                            const value = d.valueA;
                            const roundedValue = Math.round(value * 10) / 10;
                            const secondaryValue = d.valueB;
                            const label = d.label;
                            const datapoint = {
                                id: id,
                                value: roundedValue,
                                secondaryValue: secondaryValue,
                                label: label,
                            };
                            return Object.assign(Object.assign({}, datapoint), { startDate: d.startDate, endDate: d.endDate, gamesPlayed: d.valueC, tCSR: d.valueB, legacyDatapoint: d, opponentEntityBaseId: d.opponentEntityBaseId, opponentName: d.opponentName, opponentImageUrl: d.opponentImageUrl, gameId: d.gameId });
                        });
                        const colors = [
                            CS.Helper.DataVisualizationHelper.MUI_PALETTE.green["500"],
                            CS.Helper.DataVisualizationHelper.MUI_PALETTE.red["500"],
                        ];
                        const groups = datapoints.reduce((acc, datapoint) => {
                            const lastGroup = acc[acc.length - 1];
                            const lastGroupHasSameOpponentEntityBaseId = lastGroup &&
                                lastGroup.length > 0 &&
                                (lastGroup[0].opponentEntityBaseId === datapoint.opponentEntityBaseId ||
                                    lastGroup[0].startDate === datapoint.startDate);
                            if (lastGroupHasSameOpponentEntityBaseId) {
                                lastGroup.push(datapoint);
                            }
                            else {
                                acc.push([datapoint]);
                            }
                            return acc;
                        }, []);
                        if (!groups || groups.length === 0) {
                            return;
                        }
                        let index = 0;
                        groups.forEach((group, groupIndex) => {
                            const newChartId = `${canvasId}-chartv2-${groupIndex}`;
                            const $newChartContainer = $(`<div id="${newChartId}" style="margin-top: 16px;" class="t-csr-variation-by-game-datapoints-group">
          <div class="t-csr-variation-by-game-datapoints-group__header"></div>
          <div class="t-csr-variation-by-game-datapoints-group__body"></div>
        </div>`).insertBefore(canvas);
                            const $newChartContainerBody = $newChartContainer.find(".t-csr-variation-by-game-datapoints-group__body");
                            const groupDatapoints = group;
                            const firstDatapoint = groupDatapoints[0];
                            groupDatapoints.forEach((d, datapointIndex) => {
                                const containerId = `${newChartId}-opponent-${firstDatapoint.opponentEntityBaseId}-${groupIndex}-${d.id}`;
                                const serializedLegacyDatapoint = JSON.stringify(d.legacyDatapoint);
                                let csrHtml = "";
                                let avatarHtml = "";
                                let dateHtml = "";
                                const $opponentImages = $(`.csr-details-week-details-drawer-opponent-image`);
                                const $opponentImage = $($opponentImages[index]);
                                if ($opponentImage.length > 0) {
                                    avatarHtml = $opponentImage.find(".avatar")[0].outerHTML;
                                    if ($opponentImage.find(".csr").length > 0)
                                        csrHtml = $opponentImage.find(".csr")[0].outerHTML;
                                    dateHtml = $opponentImage.find(".inner-content.date").text();
                                }
                                const $matchingPlayer = $(`.cs-games-v2__game[data-game-id="${d.gameId}"] .opponent-container[data-player-id="${d.opponentEntityBaseId}"]`);
                                if ($matchingPlayer.length > 0) {
                                    avatarHtml = $matchingPlayer.find(".avatar")[0].outerHTML;
                                    if ($matchingPlayer.find(".csr").length > 0)
                                        csrHtml = $matchingPlayer.find(".csr")[0].outerHTML;
                                    dateHtml = $matchingPlayer.find(".inner-content.date").text();
                                }
                                if (!dateHtml) {
                                    dateHtml = `${d.startDate}`;
                                }
                                const $newChartItem = $(`<div id="${containerId}-datapoint-container" class="csr-datapoint hoverable" data-datapoint='${serializedLegacyDatapoint}'>
            <div class="csr-datapoint-header">
              <div class="opponent">
                <div class="opponent-image"> 
                  ${avatarHtml}
                </div>

                <div class="opponent-info">
                  <div class="opponent-name">
                    VS ${d.opponentName}
                  </div>
                  <div class="opponent-csr" style="font-size: 13px;">
                    ${csrHtml}
                  </div>
                </div>
              </div>
              <div class="date">
                ${dateHtml}
              </div>
            </div>
            <div id="${containerId}" class="csr-datapoint-body"></div>
          </div>`).appendTo($newChartContainerBody);
                                $newChartItem.offon(`click.CSRDetailsChartSetCustomElementClick2-${this.ControlId}`, (e) => {
                                    const opponentPickerOverridableUrl = $(".CSRateDetailsSectionOpponentPickerOverridableUrl").val();
                                    if (opponentPickerOverridableUrl) {
                                        // In the url, replace "-999999" by the opponentEntityBaseId
                                        const url = opponentPickerOverridableUrl.replace("-999999", d.opponentEntityBaseId);
                                        CS.Nav.Go(url);
                                    }
                                });
                                const divergingBarChart = new CS.Controls.DivergingBarChart({
                                    colors: colors,
                                    containerElementId: containerId,
                                    datapoints: [d],
                                    absoluteMaxX: absoluteMaxX,
                                });
                                divergingBarChart
                                    .init()
                                    .then(() => {
                                    // console.log("divergingBarChart initialized" + containerId);
                                })
                                    .catch((error) => {
                                    console.log("divergingBarChart initialization failed", error);
                                });
                                index++;
                            });
                        });
                    }
                    function setCustomElements(accordion, chart, context, data) {
                        CS.Lag(`CSRateDetailsSectionCharts22232`, 150, () => {
                            const $csrHeader = accordion.$Content.find(".csratedetails__header");
                            let topHeight = CS.Views.MasterPage.TopHeight;
                            const $tabMenu = $("#csr-details-wall-tab-menu");
                            if ($tabMenu.length > 0) {
                                topHeight += $tabMenu.outerHeight();
                            }
                            topHeight -= 3;
                            $csrHeader.css({
                                background: "var(--bodyBackgroundColor)",
                                position: "sticky",
                                top: `${topHeight}px`,
                                zIndex: 13,
                            });
                            const $opponents = accordion.$Content.find(".csr-details-graph-data-opponent");
                            if (!chart || !context)
                                return;
                            const dataset = data.datasets.find((d) => d.id === "t-csr-weekly-variation");
                            const chartDomRect = context.canvas.getBoundingClientRect();
                            const { scales } = chart;
                            const yTicks = scales.y.ticks;
                            const $canvasContainer = $(context.canvas).closest(".canvas-container");
                            chart.update();
                            let pixelForValue = 0;
                            let tickHeight = 0;
                            let imageWidth = 16;
                            const chartWidth = chartDomRect.width;
                            // const chartLeft = chartDomRect.left;
                            // const areaWidth = chart.chartArea.width;
                            const areaLeft = chart.chartArea.left;
                            const ticksWidth = areaLeft - 8;
                            dataset.data.forEach((dataPoint, index) => {
                                let $customElement = $canvasContainer.find(`.custom-element-${index}`);
                                if (!$customElement.length) {
                                    $canvasContainer.append(`<div class="custom-element custom-element-${index}" data-data-point='${JSON.stringify(dataPoint)}' data-custom-element-index="${index}" data-entity-base-id="${dataPoint.opponentEntityBaseId}"></div>`);
                                    $customElement = $canvasContainer.find(`.custom-element-${index}`);
                                }
                                if (!$customElement.length)
                                    return;
                                if (index == 0) {
                                    pixelForValue = scales.y.getPixelForValue(index);
                                    tickHeight = scales.y.getPixelForValue(index + 1) - pixelForValue;
                                    imageWidth = tickHeight - 8;
                                    if (imageWidth > 24) {
                                        imageWidth = 24;
                                    }
                                }
                                else {
                                    pixelForValue += tickHeight;
                                }
                                const linearGradientCssValue = `linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.05) 50%, rgba(255,255,255,0) 100%)`;
                                $customElement.css({
                                    position: "absolute",
                                    top: `${pixelForValue}px`,
                                    left: `${0}px`,
                                    width: `${chartWidth}px`,
                                    height: `${tickHeight}px`,
                                    // If index is odd, then the background is white
                                    background: index % 2 == 0 ? linearGradientCssValue : "transparent",
                                    transform: `translateY(-${tickHeight / 2}px)`,
                                    "z-index": "2",
                                    // pointerEvents: "none",
                                });
                                $customElement.addClass("hoverable");
                                $customElement.offon(`click.CSRateDetailsSectionCharts22232-${accordion.ContentId}`, (e) => {
                                    const dataPoint = JSON.parse($(e.currentTarget).attr("data-data-point"));
                                    // TODO: Trigger click on item $(".game[data-game-id='dataPoint.gameId']")
                                });
                                if (!$opponents.length) {
                                    return;
                                }
                                const correspondingOpponent = $opponents[index];
                                const $correspondingOpponent = $(correspondingOpponent);
                                const $avatar = $correspondingOpponent.find(".avatar");
                                const $info = $correspondingOpponent.find(".info");
                                $correspondingOpponent.css({
                                    position: "absolute",
                                    top: `${pixelForValue}px`,
                                    left: `${0}px`,
                                    width: `100%`,
                                    // width: `${ticksWidth}px`,
                                    //   height: `${imageWidth}px`,
                                    //   transform: `translateY(-${imageWidth / 2}px)`,
                                    transform: `translateY(-50%)`,
                                    display: "block",
                                    //   "align-items": "center",
                                    //   "justify-content": "flex-start",
                                });
                                $avatar.css({
                                    width: `${imageWidth}px`,
                                    height: `${imageWidth}px`,
                                    "flex-shrink": "0",
                                });
                            });
                        });
                    }
                    function initializeTCSRWeeklyVariationChartOverviewV2(data, accordion) {
                        var _a, _b;
                        const canvas = document.getElementById(`CSRateDetailsSectionWeekly-${accordion.ContentId}`);
                        if (!canvas)
                            return;
                        const canvasId = canvas.id;
                        canvas.style.display = "none";
                        if (!data || !data.datasets || !data.datasets.length) {
                            return;
                        }
                        const dataset = data.datasets.find((d) => d.id === "t-csr-weekly-variation");
                        if (!dataset)
                            return;
                        const parsedData = dataset.data.map((d) => {
                            const isPositiveValue = d.valueA > 0;
                            let backgroundColor = "";
                            let borderColor = "";
                            if (isPositiveValue) {
                                backgroundColor = "rgba(0,255,0,0.5)";
                                //borderColor = "rgba(0,255,0,0.75)";
                            }
                            else {
                                backgroundColor = "rgba(255,0,0,0.5)";
                                //borderColor = "rgba(255,0,0,0.75)";
                            }
                            borderColor = backgroundColor;
                            return {
                                x: d.x.replace(",", "."),
                                y: d.y,
                                valueA: d.valueA,
                                valueB: d.valueB,
                                valueC: d.valueC,
                                label: d.label,
                                backgroundColor: backgroundColor,
                                borderColor: borderColor,
                                startDate: d.startDate,
                                endDate: d.endDate,
                                userId: d.userId,
                                entityBaseId: d.entityBaseId,
                                gameId: d.gameId,
                                opponentEntityBaseId: d.opponentEntityBaseId,
                                opponentName: d.opponentName,
                                opponentImageUrl: d.opponentImageUrl,
                            };
                        });
                        let csrValue = $(".csr-and-followers .csr .value").text();
                        if (csrValue) {
                            csrValue = csrValue.split(" ")[0];
                            csrValue = csrValue.replace(/[^0-9.]/g, "");
                        }
                        const $csrHiddenValue = $(`#CSRateDetailsSectionWeeklyHiddenValue1-${accordion.ContentId}`);
                        if ($csrHiddenValue.length) {
                            csrValue = $csrHiddenValue.val();
                        }
                        const $timeframeSummary = $(`#CSRateDetailsSectionWeeklyVariationSummary-${accordion.ContentId}`);
                        const weeksCount = Math.min(dataset.data.length, 12);
                        $timeframeSummary.html(CS.Helper.formatString(JSRess.AverageTCSROverTheLastXPlayedWeeks, weeksCount, csrValue));
                        if (!parsedData || !parsedData.length) {
                            return;
                        }
                        const newChartId = `${canvasId}-chartv2`;
                        const $newChartContainer = $(`<div id="${newChartId}" style="margin-top: 16px;"></div>`).insertBefore(canvas);
                        const maxX = Math.max(...parsedData.map((d) => d.valueA));
                        const minX = Math.min(...parsedData.map((d) => d.valueA));
                        const absoluteMaxX = Math.max(Math.abs(maxX), Math.abs(minX));
                        const datapoints = parsedData.map((d, index) => {
                            const id = `datapoint-${index}`;
                            const value = d.valueA;
                            const secondaryValue = d.valueB;
                            const label = d.label;
                            const datapoint = {
                                id: id,
                                value: value,
                                secondaryValue: secondaryValue,
                                label: label,
                                secondaryLabel: CS.Helper.formatString(JSRess.TCSRIsX, d.valueB),
                            };
                            return Object.assign(Object.assign({}, datapoint), { startDate: d.startDate, endDate: d.endDate, gamesPlayed: d.valueC, tCSR: d.valueB, legacyDatapoint: d });
                        });
                        const colors = [
                            CS.Helper.DataVisualizationHelper.MUI_PALETTE.green["500"],
                            CS.Helper.DataVisualizationHelper.MUI_PALETTE.red["500"],
                        ];
                        const lang = (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.Language) !== null && _b !== void 0 ? _b : "en";
                        datapoints.forEach((d, datapointIndex) => {
                            // startDate and endDate are in this format "yyyy-mm-dd"
                            const startDateYear = d.startDate.split("-")[0];
                            const startDateMonth = d.startDate.split("-")[1];
                            const startDateDay = d.startDate.split("-")[2];
                            const endDateYear = d.endDate.split("-")[0];
                            const endDateMonth = d.endDate.split("-")[1];
                            const endDateDay = d.endDate.split("-")[2];
                            const startDate = new Date(parseInt(startDateYear), parseInt(startDateMonth) - 1, parseInt(startDateDay));
                            const endDate = new Date(parseInt(endDateYear), parseInt(endDateMonth) - 1, parseInt(endDateDay));
                            const startDateLabel = startDate.toLocaleDateString(lang, {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                            });
                            const endDateLabel = endDate.toLocaleDateString(lang, {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                            });
                            const containerId = `${newChartId}-${d.id}`;
                            const datesHtml = `<strong>${startDateLabel}</strong>&nbsp;<span>–</span>&nbsp;<strong>${endDateLabel}</strong>`;
                            const tcsrHtml = CS.Helper.formatString(JSRess.XGamesPlayed, d.gamesPlayed);
                            const serializedLegacyDatapoint = JSON.stringify(d.legacyDatapoint);
                            const $newChartItem = $(`<div id="${containerId}-datapoint-container" class="csr-datapoint hoverable" data-datapoint='${serializedLegacyDatapoint}'>
          <div class="csr-datapoint-header">
            <div class="dates">
              ${datesHtml}
            </div>
            <div class="tcsr">
              ${tcsrHtml}
            </div>
          </div>
          <div id="${containerId}" class="csr-datapoint-body"></div>
        </div>`).appendTo($newChartContainer);
                            $newChartItem.offon(`click.CSRDetailsChartSetCustomElementClick-${accordion.ContentId}`, (e) => {
                                const dataPoint = JSON.parse($(e.currentTarget).attr("data-datapoint"));
                                if (dataPoint) {
                                    const { endDate } = dataPoint;
                                    initalizeTCSRWeekDetails(accordion, endDate);
                                    const $weeksDropdown = CS.DOM.$body.find(`#dropdown-csr-details-week-picker-${accordion.ContentId}`);
                                    if ($weeksDropdown.length) {
                                        const $listItems = $weeksDropdown.find(".list-item");
                                        if ($listItems.length && datapointIndex < $listItems.length) {
                                            const correspondingListItem = $listItems[datapointIndex];
                                            const innerHtml = correspondingListItem.innerHTML;
                                            const $weeksDropdownPicker = CS.DOM.$body.find(`[data-pickerof="dropdown-csr-details-week-picker-${accordion.ContentId}"]`);
                                            if ($weeksDropdownPicker.length) {
                                                $weeksDropdownPicker.html(innerHtml);
                                            }
                                        }
                                    }
                                }
                            });
                            const divergingBarChart = new CS.Controls.DivergingBarChart({
                                colors: colors,
                                containerElementId: containerId,
                                datapoints: [d],
                                absoluteMaxX: absoluteMaxX,
                            });
                            divergingBarChart
                                .init()
                                .then(() => { })
                                .catch((error) => {
                                console.log("divergingBarChart initialization failed", error);
                            });
                        });
                    }
                    function initializeOverview(accordion) {
                        return __awaiter(this, void 0, void 0, function* () {
                            var _a, _b, _c, _d, _e, _f;
                            const $statUserGraphsInputs = accordion.$Container.find(`.CSRateDetailsSectionViewModelStatUserGraphs-${accordion.ContentId}`);
                            if ($statUserGraphsInputs.length) {
                                const itsMe = $(`.CSRateDetailsSectionViewModelItsMe-${accordion.ContentId}`).val() === "true";
                                const tooltipUpdatedOnTheMorningOf = (_b = (_a = accordion.$Container
                                    .find(`#CSRateDetailsSectionTooltipUpdatedOnTheMorningOf-${accordion.ContentId}`)
                                    .val()) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "";
                                const explanationUpdatedInTheMorning = (_d = (_c = accordion.$Container
                                    .find(`#CSRateDetailsSectionExplanationUpdatedInTheMorning-${accordion.ContentId}`)
                                    .val()) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "";
                                try {
                                    const canAccessOverviewCharts = ((_f = (_e = $(`.CSRateDetailsSectionViewModelCanAccessOverviewCharts-${accordion.ContentId}`)) === null || _e === void 0 ? void 0 : _e.val()) !== null && _f !== void 0 ? _f : "") === "true";
                                    const data = [];
                                    $statUserGraphsInputs.each((index, input) => {
                                        const $input = $(input);
                                        const val = $input.val();
                                        const parsedVal = JSON.parse(val);
                                        const isArray = Array.isArray(parsedVal);
                                        if (isArray) {
                                            data.push(...parsedVal);
                                        }
                                    });
                                    if (data.length) {
                                        // const csrChartRootId = `${accordion.ContentId}-chart-root`;
                                        // const csrChartContainerHTML = `
                                        //       <div id="${csrChartRootId}" class="">
                                        //       </div>
                                        //       `;
                                        // const csrChartControlId =
                                        //   `csr-details-summary-chart-${accordion.ContentId}`.toLowerCase();
                                        // const $csrChartControlElement = $(`#${csrChartControlId}`);
                                        // let csrChart: CS.Controls.CSRChart | null = null;
                                        const csrChartRootIdV2 = `${accordion.ContentId}-chart-root-v2`;
                                        const csrChartV2ContainerHTML = `
                      <div id="${csrChartRootIdV2}" class="">
                      </div>
                      `;
                                        const csrChartControlIdV2 = `csr-details-summary-chart-v2-${accordion.ContentId}`.toLowerCase();
                                        const $csrChartControlElementV2 = $(`#${csrChartControlIdV2}`);
                                        let csrChartV2 = null;
                                        if (
                                        // $csrChartControlElement.length &&
                                        $csrChartControlElementV2.length) {
                                            // $csrChartControlElement.append(csrChartContainerHTML);
                                            // csrChart = new CS.Controls.CSRChart(
                                            //   csrChartControlId,
                                            //   csrChartRootId,
                                            //   data,
                                            //   undefined,
                                            //   undefined,
                                            //   undefined,
                                            //   !canAccessOverviewCharts,
                                            //   itsMe
                                            // );
                                            // await csrChart.init();
                                            $csrChartControlElementV2.append(csrChartV2ContainerHTML);
                                            csrChartV2 = new CS.Controls.CSRChartV2({
                                                controlId: csrChartControlIdV2,
                                                id: csrChartRootIdV2,
                                                statUserGraphs: data,
                                                isLoggedUser: itsMe,
                                                preventInteraction: !canAccessOverviewCharts,
                                                tooltipUpdatedOnTheMorningOfText: tooltipUpdatedOnTheMorningOf,
                                                explanationUpdatedInTheMorningText: explanationUpdatedInTheMorning,
                                            });
                                            yield csrChartV2.initialize();
                                        }
                                        else {
                                            console.error("No chart container found");
                                        }
                                        const tcsrVariationChartControlId = `csr-details-tcsr-variation-chart-${accordion.ContentId}`.toLowerCase();
                                        const $tcsrVariationChartControlElement = $(`#${tcsrVariationChartControlId}`);
                                        let tcsrVariationChart = null;
                                        if ($tcsrVariationChartControlElement.length) {
                                            tcsrVariationChart = new CS.Controls.TCSRVariationChart(tcsrVariationChartControlId, data, itsMe, true, !canAccessOverviewCharts);
                                            yield tcsrVariationChart.init();
                                        }
                                        else {
                                            console.error("No tcsr variation chart container found");
                                        }
                                        if (csrChartV2 && tcsrVariationChart) {
                                            // CS.Controls.CSRChart.Events.WeekSelected({
                                            //   selector: "body",
                                            //   childSelector: `#${csrChartControlId}`,
                                            //   callback: (control, e) => {
                                            //     const { timestamp } = e.data;
                                            //     tcsrVariationChart.setWeek(timestamp);
                                            //   },
                                            // });
                                            CS.Controls.CSRChartV2.Events.WeekSelected({
                                                selector: "body",
                                                childSelector: `#${csrChartControlIdV2}`,
                                                callback: (control, e) => {
                                                    const timestamp = e.data;
                                                    tcsrVariationChart.setWeek(timestamp);
                                                },
                                            });
                                            // CS.Controls.TCSRVariationChart.Events.DatapointClicked({
                                            //   selector: "body",
                                            //   childSelector: `#${tcsrVariationChartControlId}`,
                                            //   callback: (control, e) => {
                                            //     const { timestamp } = e.data;
                                            //   },
                                            // });
                                        }
                                    }
                                }
                                catch (error) {
                                    console.error("Error while parsing stat user graphs", error);
                                }
                            }
                        });
                    }
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));
(function (CS) {
    var Controls;
    (function (Controls) {
        class CSRDetailsEventPicker extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnBindEvents() {
                const preventRedirectOnEventBoxClick = () => {
                    const $eventBoxes = this.$Control.find(".event-box");
                    $eventBoxes.each((i, e) => {
                        $(e).addClass("no-redirect");
                    });
                };
                CS.Lag("CSRDetailsEventPickerOnBindEvents", 100, () => {
                    preventRedirectOnEventBoxClick();
                });
                Controls.Accordion.Events.ContentLoaded({
                    selector: this.$Control,
                    childSelector: ".accordion-events",
                    callback: (accordion, e) => {
                        preventRedirectOnEventBoxClick();
                    },
                });
                this.$Control.offon("click.csr-details-event-picker", ".event-box", (e) => {
                    const eventId = $(e.currentTarget).attr("data-id");
                    if (eventId != null) {
                        const $overridableUrlHiddenInput = $(".CSRateDetailsSectionEventPickerOverridableUrl");
                        if ($overridableUrlHiddenInput.length) {
                            const overridableUrl = $overridableUrlHiddenInput.val();
                            if (overridableUrl) {
                                const newUrl = overridableUrl.replace("-999999", eventId);
                                console.log("Redirecting to", newUrl);
                                CS.Nav.Go(newUrl);
                            }
                        }
                    }
                });
            }
            OnControlRendered() { }
            OnDispose() { }
        }
        Controls.CSRDetailsEventPicker = CSRDetailsEventPicker;
        class CSRDetailsOpponentPicker extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.$opponents = null;
                this.$lastDates = null;
                this.opponentNames = [];
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnBindEvents() {
                const preventRedirectOnOpponentBoxClick = () => {
                    const $opponentBoxHeaders = this.$Control.find(".opponent-header");
                    $opponentBoxHeaders.each((i, e) => {
                        $(e).addClass("no-redirect");
                    });
                };
                CS.Lag("CSRDetailsEventPickerOnBindEvents", 100, () => {
                    preventRedirectOnOpponentBoxClick();
                });
                Controls.Accordion.Events.ContentLoaded({
                    selector: this.$Control,
                    childSelector: ".accordion-opponents-v2",
                    callback: (accordion, e) => {
                        preventRedirectOnOpponentBoxClick();
                    },
                });
                this.$Control.offon("click.csr-details-opponent-picker-drawer", ".opponent", (e) => {
                    const entityBaseId = $(e.currentTarget).attr("data-player-id");
                    if (entityBaseId != null) {
                        const $overridableUrlHiddenInput = $(".CSRateDetailsSectionOpponentPickerOverridableUrl");
                        if ($overridableUrlHiddenInput.length) {
                            const overridableUrl = $overridableUrlHiddenInput.val();
                            if (overridableUrl) {
                                const newUrl = overridableUrl.replace("-999999", entityBaseId);
                                CS.Nav.Go(newUrl);
                            }
                        }
                    }
                });
                let inputValue = "";
                Controls.TextBox.Events.TextChanged({
                    selector: this.$Control,
                    childSelector: ".opponent-picker-input",
                    callback: (textBox, e) => {
                        if (!this.$opponents ||
                            !this.$opponents.length ||
                            this.opponentNames.length === 0)
                            return;
                        inputValue = textBox.GetValue().trim();
                        CS.Lag("CSRDetailsOpponentPickerOnBindEvents", 250, () => {
                            if (this.$lastDates != null) {
                                this.$lastDates.each((i, e) => {
                                    if (inputValue !== "") {
                                        $(e).hide();
                                    }
                                    else {
                                        $(e).show();
                                    }
                                });
                            }
                            this.$opponents.each((i, e) => {
                                const $e = $(e);
                                const name = this.opponentNames[i];
                                if (name.toLowerCase().includes(inputValue.toLowerCase())) {
                                    $e.show();
                                }
                                else {
                                    $e.hide();
                                }
                            });
                        });
                    },
                });
                Controls.TextBox.Events.EnterKeyPressed({
                    selector: this.$Control,
                    childSelector: ".opponent-picker-input",
                    callback: (textBox, e) => {
                        textBox.$Control.find("input").blur();
                    },
                });
            }
            OnControlRendered() {
                this.$opponents = this.$Control.find(".opponent");
                this.$opponents.each((i, e) => {
                    var _a;
                    this.opponentNames.push(((_a = $(e).find(".opponent__name").text()) !== null && _a !== void 0 ? _a : "").trim().toLowerCase());
                });
                this.$lastDates = this.$Control.find(".last-date");
                let lastTicks = "";
                this.$lastDates.each((i, e) => {
                    const ticks = $(e).attr("data-ticks");
                    if (ticks) {
                        if (ticks === lastTicks) {
                            $(e).remove();
                        }
                        lastTicks = ticks;
                    }
                });
            }
            OnDispose() { }
        }
        Controls.CSRDetailsOpponentPicker = CSRDetailsOpponentPicker;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
